import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import UserAccessTypes from "@/Components/common/client/useraccess/UserAccessTypes";
import UsersList from "@/Components/common/client/useraccess/users/UsersList";
import AddUserModal from "@/Components/modals/client/UserAccessModal/AddUserModal";
import {
  deSelectAllUsers,
  fetchClientContactAlldata,
  fetchClientUsers,
  setClientUsersLoading,
  updatePagination,
} from "@/reducers/client_user/clientUsers";
import { fetchNewUserRolesData } from "@/reducers/client_user/userAccess";
import { updateactivePages } from "@/reducers/clientcommon";

import useTitle from "../../../utilities/hooks/useTitle";

const Users = () => {
  useTitle("Users");
  const { pagination } = useSelector((state) => state.clientUsers);
  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setClientUsersLoading(true));
    dispatch(deSelectAllUsers());
    dispatch(fetchClientUsers());
    dispatch(fetchNewUserRolesData());
    dispatch(
      updateactivePages({
        activePage: "userAccess",
        activeSubPage: "users",
      }),
    );
  }, []);

  useEffect(() => {
    // Runs only when the user is a primary contact.
    if (user?.is_primary_contact == 1) {
      dispatch(fetchClientContactAlldata());
    }
  }, [user.is_primary_contact]);

  return (
    <div className="flex flex-col gap-4">
      <UserAccessTypes />
      <UsersList />
      <AddUserModal />
    </div>
  );
};

export default Users;

// Client / UserAccess / RoleAccess / RoleAccess
